import type * as Types from '../../types';

import client from "apollo/client";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTenantsWithCertificatesToValidateQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  where?: Types.InputMaybe<Types.IssueFilterInput>;
  order?: Types.InputMaybe<Array<Types.IssueSortInput> | Types.IssueSortInput>;
}>;


export type GetTenantsWithCertificatesToValidateQuery = { __typename?: 'Query', issues?: { __typename: 'IssueCollectionSegment', totalCount: number, items?: Array<{ __typename: 'Issue', certificate: { __typename?: 'Certificate', id: string, certificateHolderId: string } }> | null } | null };


        export type ExecGetTenantsWithCertificatesToValidateOptions = Omit<
        Apollo.QueryOptions<
        GetTenantsWithCertificatesToValidateQueryVariables, GetTenantsWithCertificatesToValidateQuery
        >,
        "query"
      >;
    export const execGetTenantsWithCertificatesToValidateQuery = (options: ExecGetTenantsWithCertificatesToValidateOptions) =>
    client.query< GetTenantsWithCertificatesToValidateQuery, GetTenantsWithCertificatesToValidateQueryVariables>({
      ...options,
      query: GetTenantsWithCertificatesToValidateDocument,
    });
    

export const GetTenantsWithCertificatesToValidateDocument = gql`
    query getTenantsWithCertificatesToValidate($skip: Int, $take: Int, $where: IssueFilterInput, $order: [IssueSortInput!]) {
  issues(skip: $skip, take: $take, where: $where, order: $order) {
    totalCount
    items {
      certificate {
        id
        certificateHolderId
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useGetTenantsWithCertificatesToValidateQuery__
 *
 * To run a query within a React component, call `useGetTenantsWithCertificatesToValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantsWithCertificatesToValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantsWithCertificatesToValidateQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetTenantsWithCertificatesToValidateQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantsWithCertificatesToValidateQuery, GetTenantsWithCertificatesToValidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantsWithCertificatesToValidateQuery, GetTenantsWithCertificatesToValidateQueryVariables>(GetTenantsWithCertificatesToValidateDocument, options);
      }
export function useGetTenantsWithCertificatesToValidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantsWithCertificatesToValidateQuery, GetTenantsWithCertificatesToValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantsWithCertificatesToValidateQuery, GetTenantsWithCertificatesToValidateQueryVariables>(GetTenantsWithCertificatesToValidateDocument, options);
        }
export type GetTenantsWithCertificatesToValidateQueryHookResult = ReturnType<typeof useGetTenantsWithCertificatesToValidateQuery>;
export type GetTenantsWithCertificatesToValidateLazyQueryHookResult = ReturnType<typeof useGetTenantsWithCertificatesToValidateLazyQuery>;
export type GetTenantsWithCertificatesToValidateQueryResult = Apollo.QueryResult<GetTenantsWithCertificatesToValidateQuery, GetTenantsWithCertificatesToValidateQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
          export type ResultType<T> = Types.ResultType<T>;
          export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
          export type NonMaybe<T> = Types.NonMaybe<T>;
          export type Maybe<T> = Types.Maybe<T>;